import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Modal,
} from "@mui/material";

const CalendarModal = ({ open, handleClose }) => {
  const calendarInitialized = useRef(false);
  
  // This effect initializes Cal.com when the modal is opened
  useEffect(() => {
    if (open && !calendarInitialized.current) {
      // Clean up any existing scripts
      const existingScript = document.getElementById('cal-script');
      if (existingScript) {
        existingScript.remove();
      }
      
      // Create and add the Cal.com script
      const script = document.createElement('script');
      script.id = 'cal-script';
      script.type = 'text/javascript';
      script.innerHTML = `
        (function (C, A, L) { 
          let p = function (a, ar) { a.q.push(ar); }; 
          let d = C.document; 
          C.Cal = C.Cal || function () { 
            let cal = C.Cal; 
            let ar = arguments; 
            if (!cal.loaded) { 
              cal.ns = {}; 
              cal.q = cal.q || []; 
              d.head.appendChild(d.createElement("script")).src = A; 
              cal.loaded = true; 
            } 
            if (ar[0] === L) { 
              const api = function () { p(api, arguments); }; 
              const namespace = ar[1]; 
              api.q = api.q || []; 
              if(typeof namespace === "string"){
                cal.ns[namespace] = cal.ns[namespace] || api;
                p(cal.ns[namespace], ar);
                p(cal, ["initNamespace", namespace]);
              } else p(cal, ar); 
              return;
            } 
            p(cal, ar); 
          }; 
        })(window, "https://app.cal.com/embed/embed.js", "init");
        
        Cal("init", "30min", {origin:"https://cal.com"});
        
        // Automatically trigger the calendar to open once initialized
        setTimeout(() => {
          if (window.Cal && window.Cal.ns && window.Cal.ns["30min"]) {
            try {
              window.Cal.ns["30min"]("inline", {
                elementOrSelector: "#cal-embed-container",
                calLink: "beanbag.ai/30min",
                config: {"layout":"month_view"}
              });
              
              window.Cal.ns["30min"]("ui", {
                "cssVarsPerTheme": {
                  "light": {"cal-brand": "#292929"},
                  "dark": {"cal-brand": "#fafafa"}
                },
                "hideEventTypeDetails": false,
                "layout": "month_view"
              });
            } catch (e) {
              console.error("Error initializing Cal:", e);
            }
          }
        }, 100);
      `;
      
      document.head.appendChild(script);
      calendarInitialized.current = true;
    }
    
    // Clean up when modal closes
    return () => {
      if (!open) {
        calendarInitialized.current = false;
        // Try to unmount the calendar if possible
        if (window.Cal && window.Cal.ns && window.Cal.ns["30min"]) {
          try {
            window.Cal.ns["30min"]("unmount");
          } catch (e) {
            console.log("Error unmounting calendar:", e);
          }
        }
      }
    };
  }, [open]);
  
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="book-a-demo-modal"
      aria-describedby="book-a-demo-calendar"
      BackdropProps={{
        style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' }
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          // Fixed width regardless of screen size
          width: "90%",
          maxWidth: "1000px",
          // Fixed height regardless of screen size
          height: "auto",
          bgcolor: "#111111",
          boxShadow: "0px 8px 25px rgba(0, 0, 0, 0.5)",
          borderRadius: "12px",
          overflow: "hidden",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          padding: 0,
          lineHeight: 0
        }}
      >
        {/* This div will contain the Cal.com calendar */}
        <div 
          id="cal-embed-container" 
          style={{ 
            width: "100%", 
            height: "100%", 
            borderRadius: "12px",
            overflow: "hidden"
          }}
        />
      </Box>
    </Modal>
  );
};

export default CalendarModal